import { apiClient } from "@/modules/shared/utils/apiClient";

import { AVAILABILITY_TIMEOUT_MS } from "../consts/availabilityTimeout";
import { CoachAvailabilityResponse } from "../types/CoachAvailabilityResponse";
import { CoachMatchingAvailabilityRequest } from "../types/CoachMatchingAvailabilityRequest";

export const getCoachMatchingAvailability = (
  data: CoachMatchingAvailabilityRequest,
) => {
  const queryParams = new URLSearchParams(data).toString();

  return apiClient.get<CoachAvailabilityResponse>(
    `/coach-matching/availability?${queryParams}`,
    { timeoutMs: AVAILABILITY_TIMEOUT_MS },
  );
};
